// Tras un deploy, un index.html cacheado sigue pidiendo los chunks del build anterior. Como
// el hosting reescribe cualquier ruta que no encuentra a index.html, esos pedidos no dan 404: el
// import recibe HTML y la navegación a esa vista falla, dejando al usuario en la pantalla
// anterior. La salida es recargar una vez para tomar el index.html nuevo.
const PATRON_CHUNK =
  /ChunkLoadError|dynamically imported module|Importing a module script failed|error loading dynamically imported module|MIME type/i;

// Margen entre recargas: si tras recargar vuelve a fallar, es otro problema y recargar en
// bucle solo deja la pantalla parpadeando.
const ESPERA_ENTRE_RECARGAS_MS = 30_000;

// Solo se puede leer un Error o un string; cualquier otra cosa (un objeto sin toString propio
// daría "[object Object]") no dice nada sobre chunks y se trata como texto vacío.
const describir = (error: unknown): string => {
  if (error instanceof Error) {
    return `${error.name} ${error.message}`;
  }
  return typeof error === 'string' ? error : '';
};

export const esChunkDesactualizado = (error: unknown): boolean => PATRON_CHUNK.test(describir(error));

export const debeRecargar = (error: unknown, ultimaRecarga: number | null, ahora: number): boolean =>
  esChunkDesactualizado(error) &&
  (ultimaRecarga === null || ahora - ultimaRecarga > ESPERA_ENTRE_RECARGAS_MS);
